import { useCallback } from "react";
import { useFolderTree } from "../../contexts/folderTree.js";
function useFolderTreeCreatableMode() {
    const { set } = useFolderTree();
    const enterCreatableMode = useCallback(()=>{
        set({
            isTreeLinkDisabled: true,
            isCreatableLinkCancel: true,
            isToolbarActive: false
        });
    }, [
        set
    ]);
    const exitCreatableMode = useCallback(()=>{
        set({
            isTreeLinkDisabled: false,
            isCreatableLinkCancel: false,
            isToolbarActive: true
        });
    }, [
        set
    ]);
    const setCreatableModeActive = useCallback((active)=>{
        active ? enterCreatableMode() : exitCreatableMode();
    }, [
        enterCreatableMode,
        exitCreatableMode
    ]);
    return {
        enterCreatableMode,
        exitCreatableMode,
        setCreatableModeActive
    };
}
export { useFolderTreeCreatableMode };
